<div class="field field-flex compact-file">
  <label *ngIf="label" for="fileInput">{{label}}:</label>

  <!-- Estado: Sin archivo -->
  <div class="cf-row cf-empty"
       *ngIf="documentState.isEmpty"
       [class.disabled]="disabled"
       [class.drag-over]="isDragOver"
       (click)="triggerFileInput()"
       (dragover)="onDragOver($event)"
       (dragleave)="onDragLeave($event)"
       (drop)="onDrop($event)">
    <i class="fa-solid fa-arrow-up-from-bracket cf-up"></i>
    <span class="cf-up-text">Subir archivo <span class="cf-hint">· o arrastra aquí</span></span>
    <i class="fa-solid fa-circle-question cf-help" [pTooltip]="tooltip" tooltipStyleClass="custom-tooltip" [autoHide]="false"></i>
    <input type="file" #fileInput [accept]="acceptedFormats" (change)="onFileSelected($event)" [disabled]="disabled" hidden />
  </div>

  <!-- Estado: Subiendo -->
  <div class="cf-row cf-uploading" *ngIf="documentState.isUploading">
    <i class="fa-solid fa-spinner fa-spin cf-file-icon"></i>
    <div class="cf-text">
      <span class="cf-name">{{ documentState.fileName }}</span>
      <span class="cf-meta">Subiendo… {{ documentState.uploadProgress }}%</span>
    </div>
    <p-progressBar [value]="documentState.uploadProgress" [showValue]="false" styleClass="custom-progress cf-progress"></p-progressBar>
  </div>

  <!-- Estado: Archivo subido -->
  <div class="cf-row cf-uploaded" *ngIf="documentState.hasFile">
    <i class="fa-solid {{ getFileIcon(documentState.fileName!) }} cf-file-icon success"></i>
    <div class="cf-text">
      <span class="cf-name" [title]="documentState.fileName">{{ getTruncatedFileName(documentState.fileName!) }}</span>
      <span class="cf-meta" *ngIf="documentState.fileSize">
        {{ formatFileSize(documentState.fileSize) }}<span *ngIf="documentState.uploadDate"> · {{ documentState.uploadDate | date:'dd/MM/yyyy' }}</span>
      </span>
    </div>
    <div class="cf-actions">
      <button class="cf-act" type="button" (click)="onPreview()" [disabled]="disabled" pTooltip="Previsualizar" tooltipPosition="top"><i class="fa-solid fa-eye"></i></button>
      <button class="cf-act" type="button" (click)="downloadFile()" [disabled]="disabled" pTooltip="Descargar" tooltipPosition="top"><i class="fa-solid fa-download"></i></button>
      <button class="cf-act danger" type="button" (click)="deleteFile()" [disabled]="disabled" pTooltip="Eliminar" tooltipPosition="top"><i class="fa-solid fa-trash"></i></button>
    </div>
    <i class="fa-solid fa-circle-question cf-help" [pTooltip]="tooltip" tooltipStyleClass="custom-tooltip" [autoHide]="false"></i>
  </div>

  <!-- Toast para mensajes genéricos (errores de subida, etc.) -->
  <p-toast position="top-right"></p-toast>

  <!-- Toast para confirmaciones -->
  <p-toast
    key="confirm-delete"
    position="top-center"
    styleClass="custom-confirm-toast">
    <ng-template let-message pTemplate="message">
      <div class="confirm-content">
        <div class="confirm-header">
          <i class="pi pi-exclamation-triangle"></i>
          <span>{{ message.summary }}</span>
        </div>
        <div class="confirm-body">
          <p>{{ message.detail }}</p>
          <div class="confirm-actions">
            <button
              pButton
              pRipple
              type="button"
              label="Cancelar"
              icon="pi pi-times"
              class="p-button-text p-button-secondary"
              (click)="cancelDelete()">
            </button>
            <button
              pButton
              pRipple
              type="button"
              label="Eliminar"
              icon="pi pi-trash"
              class="p-button-danger"
              (click)="confirmDelete()">
            </button>
          </div>
        </div>
      </div>
    </ng-template>
  </p-toast>

  <!-- Preview dialog -->
  <app-file-preview-dialog
    [(visible)]="previewVisible"
    [fileUrl]="previewFileUrl"
    [fileName]="previewFileName"
    (downloadRequested)="downloadRequested.emit($event)">
  </app-file-preview-dialog>

</div>
